import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {QuizzesFetchParamsType, QuizzesLocationParamsType} from './types';
import type {DefaultRootState} from 'react-redux';
import type {ContentType} from 'sweet-types';

interface DashboardState {
  filters: QuizzesLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

const initialState: DashboardState = {
  filters: {} as QuizzesLocationParamsType,
  relations: {},
};

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}
export const quizSlice = createSlice({
  name: 'quizzes',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
    setQuizFilters(state, action: PayloadAction<QuizzesFetchParamsType>) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {toggleDashboardRelation, setQuizFilters} = quizSlice.actions;

export const selectQuizFilters = (
  state: DefaultRootState
): QuizzesLocationParamsType => pickBy(state.quizzes.filters);
